var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgControlRoom(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 80 68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(40, 34)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 35,
    strokeMiterlimit: 10,
    transform: "matrix(0.11 0 0 -0.109772 0 12.83)",
    d: "M-336.965 0L336.965 0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 35,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "matrix(0.11 0 0 -0.109772 0.03 0)",
    d: "M-240.579 -290.632L240.579 -290.632C296.36 -290.632 341.579 -245.412 341.579 -189.632L341.579 189.632C341.579 245.412 296.36 290.632 240.579 290.632L-240.579 290.632C-296.36 290.632 -341.579 245.412 -341.579 189.632L-341.579 -189.632C-341.579 -245.412 -296.36 -290.632 -240.579 -290.632Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    transform: "matrix(0.11 0 0 -0.109772 -15.67 22.15)",
    d: "M-31.3685 -27.658L31.3685 -27.658C37.4436 -27.658 42.3685 -22.7331 42.3685 -16.658L42.3685 16.658C42.3685 22.7331 37.4436 27.658 31.3685 27.658L-31.3685 27.658C-37.4436 27.658 -42.3685 22.7331 -42.3685 16.658L-42.3685 -16.658C-42.3685 -22.7331 -37.4436 -27.658 -31.3685 -27.658Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 30,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "matrix(0.11 0 0 -0.109772 -15.67 22.15)",
    d: "M-31.3685 -27.658L31.3685 -27.658C37.4436 -27.658 42.3685 -22.7331 42.3685 -16.658L42.3685 16.658C42.3685 22.7331 37.4436 27.658 31.3685 27.658L-31.3685 27.658C-37.4436 27.658 -42.3685 22.7331 -42.3685 16.658L-42.3685 -16.658C-42.3685 -22.7331 -37.4436 -27.658 -31.3685 -27.658Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    transform: "matrix(0.11 0 0 -0.109772 1.05 22.15)",
    d: "M-31.3685 -27.658L31.3685 -27.658C37.4436 -27.658 42.3685 -22.7331 42.3685 -16.658L42.3685 16.658C42.3685 22.7331 37.4436 27.658 31.3685 27.658L-31.3685 27.658C-37.4436 27.658 -42.3685 22.7331 -42.3685 16.658L-42.3685 -16.658C-42.3685 -22.7331 -37.4436 -27.658 -31.3685 -27.658Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 30,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "matrix(0.11 0 0 -0.109772 1.05 22.15)",
    d: "M-31.3685 -27.658L31.3685 -27.658C37.4436 -27.658 42.3685 -22.7331 42.3685 -16.658L42.3685 16.658C42.3685 22.7331 37.4436 27.658 31.3685 27.658L-31.3685 27.658C-37.4436 27.658 -42.3685 22.7331 -42.3685 16.658L-42.3685 -16.658C-42.3685 -22.7331 -37.4436 -27.658 -31.3685 -27.658Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    transform: "matrix(0.11 0 0 -0.109772 17.88 22.15)",
    d: "M-31.3685 -27.658L31.3685 -27.658C37.4436 -27.658 42.3685 -22.7331 42.3685 -16.658L42.3685 16.658C42.3685 22.7331 37.4436 27.658 31.3685 27.658L-31.3685 27.658C-37.4436 27.658 -42.3685 22.7331 -42.3685 16.658L-42.3685 -16.658C-42.3685 -22.7331 -37.4436 -27.658 -31.3685 -27.658Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 30,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "matrix(0.11 0 0 -0.109772 17.88 22.15)",
    d: "M-31.3685 -27.658L31.3685 -27.658C37.4436 -27.658 42.3685 -22.7331 42.3685 -16.658L42.3685 16.658C42.3685 22.7331 37.4436 27.658 31.3685 27.658L-31.3685 27.658C-37.4436 27.658 -42.3685 22.7331 -42.3685 16.658L-42.3685 -16.658C-42.3685 -22.7331 -37.4436 -27.658 -31.3685 -27.658Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 35,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "matrix(0.11 0 0 -0.109772 25.29 -7.53)",
    d: "M0 -181.147L0 181.147",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 35,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "matrix(0.11 0 0 -0.109772 8.76 -7.53)",
    d: "M0 -181.147L0 181.147",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 35,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "matrix(0.11 0 0 -0.109772 -7.71 -7.53)",
    d: "M0 -181.147L0 181.147",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 35,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "matrix(0.11 0 0 -0.109772 -24.24 -7.53)",
    d: "M0 -181.147L0 181.147",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgControlRoom);
export default __webpack_public_path__ + "static/media/ControlRoom.9178b2d5e7006649b90901e851cf22c9.svg";
export { ForwardRef as ReactComponent };